import React from 'react';

import HelpArticleLink from '../../../components/help-article-link';
import { linkIDs } from '../../../services/link-service/links';

import style from './rate-recommendation.module.less';
import { InsuranceProviders } from '../../../enums/insurance-providers';

/**
 * @param {object} props
 * @param {string} props.insuranceProviderName
 * @returns {React.JSX.Element|string}
 */
export const RecommendedInsuranceProviderName = ({ insuranceProviderName = '' }) => {
  if (insuranceProviderName === InsuranceProviders.ParcelGuard.name) {
    return (
      <HelpArticleLink articleId={linkIDs.ParcelGuardKB} className={style['help-link']}>
        {InsuranceProviders.ParcelGuard.name}
      </HelpArticleLink>
    );
  }

  return insuranceProviderName;
};
